import React from 'react';

import './_progressIndicator.scss';

interface Props {
  step: number;
  totalSteps: number;
}

const ProgressIndicator = ({ step, totalSteps }: Props) => {
  const value = (step / totalSteps) * 100;
  return (
    <div className="flex flex-start items-center gap-3">
      <div className="text-xs font-normal text-subdued">
        {step}/{totalSteps}
      </div>
      <div className="progress-indicator-main-container">
        <div className="progress-indicator-inner-div" style={{ width: `${value}%` }}></div>
      </div>
    </div>
  );
};

export default ProgressIndicator;
